import { bodyBgSize } from './BodyBgStore';

export const updateBodyBgSize = (value) => bodyBgSize.update(oldValue => value);
